namespace advisorop.components.common {

    class SearchProductOrManagerController {

        onValueSelected: any;
        selectedValue: any;

        // for internal use
        searching = false;
        noResults = false;

        static $inject = ["managerApi"];
        constructor(
            private managerApi: services.ManagerApi
        ) {
        }

        $onInit(): void {
        };

        $routerOnActivate(next, previous) {
        };
        
        search(searchTerm: string): ng.IPromise<{}> {
            return this.managerApi.searchProductOrManager(searchTerm).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var value = {};
            angular.copy(this.selectedValue, value);
            this.onValueSelected({value});
        };
        
    }



    class SearchProductOrManager implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onValueSelected: "&",
            };
            this.controller = SearchProductOrManagerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/search-product-or-manager.html';
        }
    }
    angular.module(Constants.APP).component("searchProductOrManager", new SearchProductOrManager());
    
}